import React, { useContext } from "react";
import TypographyContainer from "../../../ui/layout/page/typography-container/typography-base-container";
import TypographyItemContainer from "../../../ui/layout/page/typography-container/typography-item-container";
import Typography from "../../../ui/widgets/typography";
import FormFullWidthContainer from "../../../ui/layout/page/forms-container/form-full-width-container";
import ProductSelection from "../../../ui/widgets/product-selection";
import { useMessageSource } from "react-message-source";
import { ProductContext } from "../../../context/product-context/productContext";
import GTM from "../../../util/tracking/gtm";
import { ApplicationFlowSteps } from "../../../route/application/authenticated/application-flow/types";
import { ProductRefType } from "../../../context/product-context/types";
import { LanguageContext } from "../../../context/languageContext";

const ProductOffer = (): React.JSX.Element => {
  const { getMessage: t } = useMessageSource();
  const { selectedProduct, setSelectedProduct, findProduct } =
    useContext(ProductContext);
  const { language } = useContext(LanguageContext);

  if (selectedProduct === undefined) {
    return null;
  }
  return (
    <>
      <TypographyContainer>
        <TypographyItemContainer>
          <Typography variant="h3">{t("ProductOffer")}</Typography>
        </TypographyItemContainer>
      </TypographyContainer>
      <FormFullWidthContainer>
        <ProductSelection
          selectedProduct={selectedProduct}
          onSelectCallback={(productRef: ProductRefType) => {
            const newProduct = findProduct(productRef);
            setSelectedProduct(newProduct, true);
            GTM.trackVirtualPageView(
              ApplicationFlowSteps.COMPANY,
              newProduct.productRef,
              language,
            );
          }}
        />
      </FormFullWidthContainer>
    </>
  );
};

export default ProductOffer;
